import { SearchPage } from '@obeta/layouts/lib/searchPage/SearchPage'

export default SearchPage

export async function getStaticProps() {
  return {
    props: {},
  }
}
